<script>
import Utils from 'core/utilities/Utils.js'

export default {
    created () {
        this.legalHref = `${window.location.origin}/?modal=legal`
        this.legalRoute = {
            query: Utils.updateQueryParams(this.$route.query, { modal: 'legal' })
        }
    }
}
</script>

<style lang="postcss" scoped>
h2,
h3,
h4 {
    margin: 1.33em 0 0.33em;
}

h4 {
    font-style: italic;
    font-weight: bold;
}

li {
    list-style: disc;
}

ol,
p,
ul {
    margin: 0.33em 0;
}

ul {
    margin-left: 18px;
}
</style>
